import { render, staticRenderFns } from "./PageMar.vue?vue&type=template&id=d503910e&"
import script from "./PageMar.vue?vue&type=script&lang=js&"
export * from "./PageMar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports